var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName,"duration":{ enter: 1500, leave: 1500 }}},[_c('router-view')],1),_c('toast',{ref:"toastN"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }